import { calculatePricing } from "@/lib/pricing";
import type { BookingState, DiscountResult, PricingResult } from "@/types/booking";

const delay = (ms: number) => new Promise((resolve) => window.setTimeout(resolve, ms));

export async function getPrices(_postcode: string, _service: BookingState["service"], _selectedOptions: unknown, bookingState: BookingState): Promise<PricingResult> {
  await delay(180);
  return calculatePricing(bookingState);
}

export async function validateDiscountCode(code: string, bookingState: BookingState): Promise<DiscountResult> {
  await delay(350);
  const normalized = code.trim().toUpperCase();
  const pricing = calculatePricing({ ...bookingState, discountResult: null });
  const subtotal = pricing.baseServicePrice + pricing.supplementalItemsTotal;

  if (normalized === "SAVE10") {
    return { code: normalized, type: "percentage", value: 10, amount: Math.round(subtotal * 0.1), message: "10% discount applied." };
  }

  if (normalized === "WASTE25") {
    return { code: normalized, type: "fixed", value: 25, amount: 25, message: "GBP 25 discount applied." };
  }

  throw new Error("Discount code was not recognised.");
}

export async function createPaymentIntent(_bookingState: BookingState, pricingResult: PricingResult) {
  await delay(500);
  return {
    id: `pi_mock_${Date.now()}`,
    clientSecret: `pi_mock_secret_${pricingResult.totalPayable}`,
  };
}

export async function confirmPayment(paymentIntentId: string) {
  await delay(700);
  if (!paymentIntentId) {
    throw new Error("Payment could not be started. Please retry.");
  }

  return {
    status: "succeeded" as const,
    bookingReference: `WK-${new Date().getFullYear()}-${String(Date.now()).slice(-6)}`,
  };
}
